<div class="row g-4 m-0">
    <div [class]="sidebarSection() ? 'col-lg-8' : 'col-12'">
        @for (row of sectionsRows(); track $index; let rowIndex = $index) {
            @if (row.length > 0) {
                @if(row[0].section_type ==='title') {
                    <h1 class="p-4 ps-5">
                        {{row[0].content.replace(/\$\w+/g, '')}}
                    </h1>
                } @else {
                    <div class="row justify-content-start align-content-center business-case m-2 businessDocumentsChoose addedForStyleAncorTag">
                        @for (item of row; track $index; let itemIndex = $index) {
                            @if (item.section_type === 'faq') {
                                <div [class]="'col-md-'+(12/row.length)" class="faq-container my-3">
                                    <div class="faq-header mb-4 text-center text-md-start">
                                        <span class="faq-badge badge px-3 py-2 rounded-pill mb-2">FAQ</span>
                                        <h2 class="faq-section-title fw-bold mb-2">
                                            {{ item.title || 'Frequently Asked Questions' }}
                                        </h2>
                                        @if (item.subtitle) {
                                            <p class="faq-section-subtitle text-muted">{{ item.subtitle }}</p>
                                        }
                                    </div>
                                    <div class="accordion custom-faq-accordion" [id]="'faqAccordion-biz-' + rowIndex + '-' + itemIndex">
                                        @for (faq of parseFaq(item.content); track $index; let faqIndex = $index) {
                                            <div class="accordion-item mb-3 border rounded-3 shadow-sm overflow-hidden">
                                                <h2 class="accordion-header" [id]="'heading-biz-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                                    <button 
                                                        class="accordion-button fw-semibold py-3 px-4" 
                                                        [class.collapsed]="faqIndex !== 0"
                                                        type="button" 
                                                        data-bs-toggle="collapse" 
                                                        [attr.data-bs-target]="'#collapse-biz-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                        [attr.aria-expanded]="faqIndex === 0 ? 'true' : 'false'" 
                                                        [attr.aria-controls]="'collapse-biz-' + rowIndex + '-' + itemIndex + '-' + faqIndex">
                                                        <span class="faq-question-text">{{ faq.question }}</span>
                                                    </button>
                                                </h2>
                                                <div 
                                                    [id]="'collapse-biz-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                    class="accordion-collapse collapse" 
                                                    [class.show]="faqIndex === 0"
                                                    [attr.aria-labelledby]="'heading-biz-' + rowIndex + '-' + itemIndex + '-' + faqIndex" 
                                                    [attr.data-bs-parent]="'#faqAccordion-biz-' + rowIndex + '-' + itemIndex">
                                                    <div class="accordion-body p-4 bg-white text-secondary">
                                                        <div [innerHTML]="faq.answers || faq.answer" class="dynamic-content-col"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            } @else if (item.section_type !== 'sidebar') {
                                <div [innerHTML]="item.content"></div>    
                            }
                        }
                    </div>
                }
            }
        }
    </div>

    @if (sidebarSection()) {
        <div class="col-lg-4">
            <div class="sidebar-section-card p-4 rounded-4 shadow-sm bg-white border border-light-subtle my-3 position-sticky" style="top: 2rem;">
                <div class="sidebar-header mb-3">
                    <span class="sidebar-badge badge px-3 py-2 rounded-pill mb-2 bg-primary-subtle text-primary fw-bold">Information</span>
                    @if (sidebarSection()?.title) {
                        <h3 class="sidebar-title fw-bold text-dark mb-1">
                            {{ sidebarSection()?.title }}
                        </h3>
                    }
                    @if (sidebarSection()?.subtitle) {
                        <p class="sidebar-subtitle text-muted small mb-0">
                            {{ sidebarSection()?.subtitle }}
                        </p>
                    }
                </div>
                <div [innerHTML]="sidebarSection()?.content" class="sidebar-body dynamic-content-col"></div>
            </div>
        </div>
    }
</div>
